import React, { useState } from 'react';
import { Nav, NavDropdown, Spinner } from 'react-bootstrap';
import {
  PeopleFill,
  ClipboardCheck,
  ClipboardData,
  Gear,
  FileEarmarkText,
  ShieldLock,
  PersonBadge,
} from 'react-bootstrap-icons';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const isConfigActive = location.pathname.startsWith('/administrador/config');
  const [showConfig, setShowConfig] = useState(false);

  const { user, loading } = useAuth();

  const handleLinkClick = () => {
    if (window.innerWidth < 768 && onClose) {
      onClose();
    }
  };

  if (loading) {
    return (
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="d-flex justify-content-center align-items-center h-100">
          <Spinner animation="border" variant="primary" />
        </div>
      </div>
    );
  }

  return (
    <>
      {isOpen && (
        <div 
          className="sidebar-overlay open" 
          onClick={onClose}
        />
      )}
      
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <Nav className="flex-column w-100">
          {user?.rol === 'superusuario' && (
            <Nav.Item>
              <Link
                to="/administrador/administrar-usuarios"
                className={`nav-link ${location.pathname === '/administrador/administrar-usuarios' ? 'active' : ''}`}
                onClick={handleLinkClick}
              >
                <PersonBadge className="me-2" />
                Gestión de Usuarios
              </Link>
            </Nav.Item>
          )}

          <Nav.Item>
            <Link
              to="/administrador/proveedores"
              className={`nav-link ${location.pathname === '/administrador/proveedores' ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <PeopleFill className="me-2" />
              Proveedores
            </Link>
          </Nav.Item>

          <Nav.Item>
            <Link
              to="/administrador/formularios"
              className={`nav-link ${location.pathname === '/administrador/formularios' ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <FileEarmarkText className="me-2" />
              Formularios
            </Link>
          </Nav.Item>

          <Nav.Item>
            <Link
              to="/administrador/evaluacion"
              className={`nav-link ${location.pathname === '/administrador/evaluacion' ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <ClipboardData className="me-2" />
              Evaluación
            </Link>
          </Nav.Item>

          <Nav.Item>
            <Link
              to="/administrador/calificacion"
              className={`nav-link ${location.pathname === '/administrador/calificacion' ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <ClipboardCheck className="me-2" />
              Calificación
            </Link>
          </Nav.Item>

          <NavDropdown
            title={
              <span className="d-flex align-items-center">
                <Gear className="me-2" />
                Configuración
              </span>
            }
            id="config-dropdown"
            className={`w-100 ${isConfigActive ? 'active' : ''}`}
            show={showConfig}
            onToggle={setShowConfig}
          >
            <NavDropdown.Item
              as={Link}
              to="/administrador/archivos"
              active={location.pathname === '/administrador/archivos'}
              className="dropdown-item d-flex align-items-center"
              onClick={handleLinkClick}
            >
              <FileEarmarkText className="me-2" />
              Archivos
            </NavDropdown.Item>

            <NavDropdown.Item
              as={Link}
              to="/administrador/politicas"
              active={location.pathname === '/administrador/politicas'}
              className="dropdown-item d-flex align-items-center"
              onClick={handleLinkClick}
            >
              <ShieldLock className="me-2" />
              Políticas
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </div>
    </>
  );
};

export default Sidebar;